import Packlists from './Packlists'

export default Packlists



// WEBPACK FOOTER //
// ./src/components/Reports/Packlists/index.js